import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { ContactType, CreateContactInput } from "@/gql/graphql";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { ContactDetailsForm } from "@/app/Contacts/Forms/ContactDetailsForm";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { contactValidation } from "@/app/Contacts/Forms/contactValidation";
import { FormDivider } from "@/lib/Components/Form/Components/FormDivider";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { createContactMutation } from "@/app/Contacts/GraphQL/contactMutations";
import { AddressInput } from "@/app/Address/Components/AddressInput";
import { toFormikValidationSchema } from "@/lib/Zod/zod-formik-adapter";
import { DialogComponent } from "@/lib/Components/Dialog/Hooks/useDialog";
import { ContactListItem } from "@/app/Contacts/GraphQL/contactListQuery";

export type ContactCreateDialogProps = {
  initialValues: Partial<CreateContactInput>;
};
export const ContactCreateDialog: DialogComponent<
  ContactCreateDialogProps,
  ContactListItem
> = ({ initialValues }) => {
  const { mutateAsync } = useGqlMutation(createContactMutation);
  const { close, resolve } = useDialogState<ContactListItem>();

  return (
    <BaseDialog title={"Add contact"}>
      <GenericForm<CreateContactInput>
        validationSchema={toFormikValidationSchema(contactValidation)}
        initialValues={{
          name: "",
          type: ContactType.Guest,
          billingAddress: {
            upsert: {
              address_line_1: "",
              address_line_2: "",
              city: "",
              country: "",
            },
          },
          ...initialValues,
        }}
        onSubmit={async (values) => {
          const res = await mutateAsync({
            input: values,
          });

          resolve?.(res.createContact);

          await close();
        }}
      >
        <ContactDetailsForm />
        <FormDivider />
        <AddressInput
          name="billingAddress.upsert"
          label="Address"
          className="col-span-6"
        />
        <DialogSubmitButton text={"Add contact"} />
      </GenericForm>
    </BaseDialog>
  );
};
